import '../../css/pages/tour-guide.css';
import { initShell } from '../lib/shell';

initShell();

// Full-screen step reader for Guide Mode. Each talking point (see
// pages/tour-guide.php / content/tour-guide/walkthrough.json) opens into a
// full-screen overlay with a scrollable body and Prev/Next navigation —
// modeled on the Moments page's lightbox (src/ts/pages/moments.ts), just
// stepping through an ordered list instead of a single image.

interface GuideStep {
  title: string;
  subtitle: string;
  content: string[];
  progress: string;
}

declare global {
  interface Window {
    __GUIDE_STEPS__?: GuideStep[];
  }
}

const steps = window.__GUIDE_STEPS__ ?? [];

const startBtn = document.getElementById('guide-start-btn');
const cards = document.querySelectorAll<HTMLButtonElement>('.guide-list__card');

const reader = document.getElementById('guide-reader');
const readerProgress = document.getElementById('guide-reader-progress');
const readerTitle = document.getElementById('guide-reader-title');
const readerSubtitle = document.getElementById('guide-reader-subtitle');
const readerBody = document.getElementById('guide-reader-body');
const readerScroll = document.querySelector<HTMLElement>('.guide-reader__scroll');
const readerClose = document.getElementById('guide-reader-close');
const readerBackdrop = document.getElementById('guide-reader-backdrop');
const readerPrev = document.getElementById('guide-reader-prev') as HTMLButtonElement | null;
const readerNext = document.getElementById('guide-reader-next') as HTMLButtonElement | null;

let currentIndex = 0;

function renderStep(index: number): void {
  const step = steps[index];
  if (!step) return;

  currentIndex = index;

  if (readerProgress) readerProgress.textContent = step.progress;
  if (readerTitle) readerTitle.textContent = step.title;
  if (readerSubtitle) readerSubtitle.textContent = step.subtitle;
  if (readerBody) {
    readerBody.innerHTML = '';
    step.content.forEach((paragraph) => {
      const p = document.createElement('p');
      p.textContent = paragraph;
      readerBody.appendChild(p);
    });
  }
  if (readerScroll) readerScroll.scrollTop = 0;

  if (readerPrev) readerPrev.disabled = index <= 0;
  if (readerNext) readerNext.disabled = index >= steps.length - 1;
}

function openReader(index: number): void {
  if (!steps.length) return;
  renderStep(index);
  reader?.classList.add('is-open');
  reader?.setAttribute('aria-hidden', 'false');
  document.body.classList.add('guide-reader-active');
}

function closeReader(): void {
  reader?.classList.remove('is-open');
  reader?.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('guide-reader-active');
}

startBtn?.addEventListener('click', () => openReader(0));

cards.forEach((card) => {
  card.addEventListener('click', () => {
    const idx = Number(card.dataset.step ?? '0');
    openReader(idx);
  });
});

readerClose?.addEventListener('click', closeReader);
readerBackdrop?.addEventListener('click', closeReader);

readerPrev?.addEventListener('click', () => {
  if (currentIndex > 0) renderStep(currentIndex - 1);
});
readerNext?.addEventListener('click', () => {
  if (currentIndex < steps.length - 1) renderStep(currentIndex + 1);
});

document.addEventListener('keydown', (e) => {
  if (!reader?.classList.contains('is-open')) return;
  if (e.key === 'Escape') closeReader();
  if (e.key === 'ArrowLeft' && currentIndex > 0) renderStep(currentIndex - 1);
  if (e.key === 'ArrowRight' && currentIndex < steps.length - 1) renderStep(currentIndex + 1);
});
